import React from 'react';
import FamilyListItem from './FamilyListItem';

/**
 * FamilyList component
 * Displays the list of families with selection and edit capabilities
 */
export default function FamilyList({
    loading,
    families,
    projects,
    filteredFamilies,
    selectedFamilyId,
    isEditMode,
    onSelectFamily,
    onEditFamily,
    onExportFamily,
    onShareFamily,
    onDeleteFamily,
    onOpenSimulator
}) {
    if (loading && families.length === 0) {
        return (
            <div style={{ 
                flex: 1, 
                overflowY: 'auto', 
                padding: '1rem', 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '0.75rem' 
            }}>
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    padding: '2rem' 
                }}>
                    <div className="loader" style={{ width: '24px', height: '24px', margin: 0 }}></div>
                </div>
            </div>
        );
    }

    if (filteredFamilies.length === 0) {
        return (
            <div style={{ 
                flex: 1, 
                overflowY: 'auto', 
                padding: '1rem', 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '0.75rem' 
            }}>
                <div style={{ 
                    textAlign: 'center', 
                    padding: '2rem', 
                    color: 'var(--text-secondary)', 
                    fontSize: '0.9rem' 
                }}>
                    No families found.
                </div>
            </div>
        );
    }

    return (
        <div style={{
            flex: 1,
            overflowY: 'auto',
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }}>
            {filteredFamilies.map(f => (
                <FamilyListItem
                    key={f.id}
                    family={f}
                    projects={projects}
                    isSelected={selectedFamilyId === f.id}
                    onSelectFamily={onSelectFamily}
                    onEditFamily={onEditFamily}
                    onExportFamily={onExportFamily}
                    onShareFamily={onShareFamily}
                    onDeleteFamily={onDeleteFamily}
                    onOpenSimulator={onOpenSimulator}
                />
            ))}
        </div>
    );
}
